/* Sawt Al Zaman — interactions: scroll reveal, email popup, sticky ATC */
(function () {
  'use strict';

  function initReveal() {
    var els = document.querySelectorAll('.saz-reveal');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('saz-revealed'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('saz-revealed');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  function initPopup() {
    var popup = document.getElementById('SazPopup');
    if (!popup) return;

    var KEY = 'saz-popup-shown';
    var DAYS = 15;
    try {
      if (localStorage.getItem('saz-subscribed')) return;
      var last = localStorage.getItem(KEY);
      if (last && Date.now() - parseInt(last, 10) < DAYS * 864e5) return;
    } catch (e) { return; }

    if (location.pathname.indexOf('/cart') === 0 || location.pathname.indexOf('/checkouts') === 0) return;

    if (location.search.indexOf('customer_posted=true') !== -1) {
      try { localStorage.setItem('saz-subscribed', '1'); } catch (e) {}
      return;
    }

    var opened = false;
    function open() {
      if (opened) return;
      opened = true;
      popup.classList.add('saz-popup--open');
      try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
    }
    function close() {
      popup.classList.remove('saz-popup--open');
    }

    setTimeout(open, 9000);
    var scrollHandler = function () {
      var scrolled = window.scrollY / Math.max(1, document.body.scrollHeight - window.innerHeight);
      if (scrolled > 0.45) {
        open();
        window.removeEventListener('scroll', scrollHandler);
      }
    };
    window.addEventListener('scroll', scrollHandler, { passive: true });

    popup.querySelectorAll('[data-saz-popup-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
    var form = popup.querySelector('form');
    if (form) {
      form.addEventListener('submit', function () {
        try { localStorage.setItem('saz-subscribed', '1'); } catch (e) {}
      });
    }
  }

  function initStickyAtc() {
    var bar = document.getElementById('SazStickyAtc');
    if (!bar) return;
    var productForm = document.querySelector('product-form form[data-type="add-to-cart-form"], form[data-type="add-to-cart-form"]');
    var nativeSubmit = document.querySelector('.product-form__submit');
    if (!productForm || !nativeSubmit) return;

    var btn = bar.querySelector('.saz-sticky-atc__btn');
    btn.addEventListener('click', function () {
      if (typeof productForm.requestSubmit === 'function') productForm.requestSubmit();
      else nativeSubmit.click();
    });

    function sync() {
      btn.disabled = nativeSubmit.disabled;
      btn.textContent = nativeSubmit.disabled
        ? (window.variantStrings && window.variantStrings.soldOut) || 'Sold out'
        : bar.dataset.label || 'Add to cart';
      var priceEl = document.querySelector('.price__regular .price-item--regular, .price-item--regular');
      var target = bar.querySelector('.saz-sticky-atc__price');
      if (priceEl && target) target.textContent = priceEl.textContent.trim();
    }
    sync();
    new MutationObserver(sync).observe(nativeSubmit, { attributes: true, childList: true, subtree: true });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          bar.classList.toggle('saz-sticky-atc--visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
        },
        { threshold: 0 }
      );
      io.observe(nativeSubmit);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initReveal();
      initPopup();
      initStickyAtc();
    });
  } else {
    initReveal();
    initPopup();
    initStickyAtc();
  }
})();
